import { Injectable } from '@angular/core'
import { HttpHeaders } from '@angular/common/http';
import { HttpClient, HttpParams, } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
@Injectable()
export class BaseService {
// base_url = 'http://localhost:8000/api/'
// base_url = 'https://robin.bon-voyage.services/api/';
// url = 'http://api.zippopotam.us/us/90210'

base_url = 'https://robin-sass.pioneers.network/api/'
file_url = 'https://robin-sass.pioneers.network/'
// base_url = 'https://robin-sass.pioneers.network/api'

// file_url = 'https://robin.bon-voyage.services/';

//token  = localStorage.getItem('token')
token 
// = JSON.parse(localStorage.getItem('user')).token;

 

  subject_Change = new Subject();

  Change = false
  set_provider(loading ){
  this.subject_Change.next(loading);
   }
  constructor( private http: HttpClient) {
    if(JSON.parse(localStorage.getItem('user'))){
  this.token  = JSON.parse(localStorage.getItem('user')).token;
  console.log(' this.token', this.token);
    }
    console.log(this.token)
   }
 
 // ------------------------------------------------------------------------------------------
   get(url: String) {
    if(JSON.parse(localStorage.getItem('user'))){
      this.token  = JSON.parse(localStorage.getItem('user')).token;
      console.log(' this.token', this.token);
        }
    return new Promise((resolve, reject) => {


      let header = new HttpHeaders();
      header.append('Accept', 'application/json');
      header.append('Authorization', 'Bearer ' +this.token);
      header.append('Access-Control-Allow-Headers', 'Content-Type');
      header.append('Access-Control-Allow-Methods', 'GET');
      header.append('Access-Control-Allow-Origin', '*');
      this.http
        .get(this.base_url + url, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + this.token,
          },
        })
        .subscribe(
          (res) => {
            return resolve(res);
          },
          (err) => {
            return reject(err);
          }
        );
    });
  }
  // ------------------------------------------------------------------------------------------
  delete(url: String) {
    if(JSON.parse(localStorage.getItem('user'))){
      this.token  = JSON.parse(localStorage.getItem('user')).token;
      console.log(' this.token', this.token);
        }
    return new Promise((resolve, reject) => {
      let header = new HttpHeaders();
      header.append('Accept', 'application/json');
      header.append('Authorization', 'Bearer ' + this.token);
      header.append('Access-Control-Allow-Headers', 'Content-Type');
      header.append('Access-Control-Allow-Methods', 'DELETE');
      header.append('Access-Control-Allow-Origin', '*');
      this.http
        .delete(this.base_url + url, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + this.token,
          },
        })
        .subscribe(
          (res) => {
            return resolve(res);
          },
          (err) => {
            return reject(err);
          }
        );
    });
  }
  // ------------------------------------------------------------------------------------------
  post(url: String, data: any) {
    // console.log(data);
    if(JSON.parse(localStorage.getItem('user'))){
      this.token  = JSON.parse(localStorage.getItem('user')).token;
      console.log(' this.token', this.token);
        }
    return new Promise((resolve, reject) => {
      let header = new HttpHeaders();
      header.append('Accept', 'application/json');
      header.append('Authorization', 'Bearer ' +this.token);
      header.append('Access-Control-Allow-Headers', 'Content-Type');
      header.append('Access-Control-Allow-Methods', 'POST');
      header.append('Access-Control-Allow-Origin', '*');
      this.http
        .post(this.base_url + url, data, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + this.token,
          },
        })
        .subscribe(
          (res) => {
            return resolve(res);
          },
          (err) => {
            return reject(err);
          }
        );
    });
  }
  //-------------------------------------------------------------------------------------------

//   postFile(url: String , file: File) {

//         //  console.log(fileToUpload)
  
//         return new Promise((resolve, reject) => {
  
//           // const formData: FormData = new FormData();
  
//           // formData.append('fileKey', fileToUpload, fileToUpload.name);
          
//           let formData: FormData = new FormData();
//           formData.append('file', file, file.name);
  
//           console.log(formData)
  
//           let header = new HttpHeaders();
//           // header.append('Accept', 'application/json');
//           header.append('Authorization', 'Bearer ' +this.token);
  
//           this.http
//             .post(this.base_url + url, formData , {
//               headers: {
//                 // Accept: 'application/json',
//                 Authorization: 'Bearer ' + localStorage.getItem('token'),
//               },
//             })
//             .subscribe(
//               (res) => {
//                 return resolve(res);
//               },
//               (err) => {
//                 return reject(err);
//               }
//             );
//         });
// }

postFile1(url: String,file: File,linked_id:any,lniked_type:any,document_id:any){
  let formData: FormData = new FormData();
  formData.append('file', file, file.name);
  formData.append('linked_id', linked_id );
  formData.append('linked_type', lniked_type );
  formData.append('document_id', document_id );
  // let header = new HttpHeaders();
  // header.append('Accept', 'application/json');
  // header.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  return this.http.post(`${this.base_url + url}`, formData, {
    headers:  
    {
      // Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token'),
    }
    , 
    responseType: 'text'
  });
}

postFile(url: String,file: File,linked_id:any,lniked_type:any,document_id:any){
  let formData: FormData = new FormData();
  formData.append('file', file, file.name);
  formData.append('linked_id', linked_id );
  formData.append('linked_type', lniked_type );
  formData.append('document_id', document_id );
  // let header = new HttpHeaders();
  // header.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  return this.http.post(`${this.base_url + url}`, formData, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
    }
    // , responseType: 'text'
  });
}

}
